import Store from 'repatch';
import State from '../core/State';
import {
  setIncludePreviousFlag,
  dispose,
  setFromPeriod,
  setToPeriod,
  setFromSubPeriod,
  setToSubPeriod,
} from '../thunk/globalChartSetting';
import { DateTime } from 'luxon';

class EditGlobalChartSettingUsecase {
  private store: Store<State>;

  constructor({ store }: { store: Store<State> }) {
    this.store = store;
  }

  public setFromPeriod = (date: DateTime | null): void => {
    if (date) {
      this.store.dispatch(setFromPeriod(date));
    }
  };

  public setToPeriod = (date: DateTime | null): void => {
    if (date) {
      this.store.dispatch(setToPeriod(date));
    }
  };

  public setFromSubPeriod = (date: DateTime | null): void => {
    if (date) {
      this.store.dispatch(setFromSubPeriod(date));
    }
  };

  public setToSubPeriod = (date: DateTime | null): void => {
    if (date) {
      this.store.dispatch(setToSubPeriod(date));
    }
  };

  public setIncludePreviousFlag = (flag: boolean): void => {
    this.store.dispatch(setIncludePreviousFlag(flag));
  };

  public dispose = (): void => {
    this.store.dispatch(dispose());
  };
}

export default EditGlobalChartSettingUsecase;
